import { Component, Input, OnDestroy, OnInit, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FwcModalSlide, FwcPreloader } from '../../../../fwc-lib.js';
import { Subscription } from 'rxjs';
import { AppConstants } from '../../../common/constants/app-constants';
import { DataService } from '../../../common/services/data.service';
import { UserCacheService } from '../../../common/services/user-cache.service';
import { TokenService } from '../../services/token.service';

@Component({
    selector: 'sae-secure-global-header',
    templateUrl: './secure-global-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SecureGlobalHeaderComponent implements OnDestroy, OnInit {
  @Input() stories: any;
  @ViewChild('accountMenu') accountMenu: ElementRef;
  @ViewChild('reportingMenu') reportingMenu: ElementRef;
  @ViewChild('managementMenu') managementMenu: ElementRef;
  @ViewChild('fwcSlideChild') sliderChild: ElementRef;
  @ViewChild('fwcSlideParent') sliderParent: ElementRef;
  @ViewChild('fwcSlideContent') sliderContent: ElementRef;
  showAccountMenu = false;
  showReportingMenu = false;
  showManagementMenu = false;
  showNavBackground = false;
  displaySpinner = false;
  header: {
    brandLogo: string,
    universityLogo: string,
    universityLabel: string
  };
  token: string;
  modal: any;
  private ds: any;
  changeStorySubscription: any;
  logoutObs: Subscription;
  constructor(
    public userCacheService: UserCacheService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    public dataService: DataService,
    public logoutService: TokenService
  ) {
    const fwcPreloader = new FwcPreloader();
    fwcPreloader.build();
    this.header = this.userCacheService.getUserData(AppConstants.GLOBAL_HEADER);
    // this.token = localStorage.getItem(AppConstants.TOKEN);
    this.token = this.getCookie(AppConstants.TOKEN);

  }

  getCookie(name: string) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i++) {
        let c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  navigateTo(path: string): void {
    if (path === '/secure/students') {
      this.activatedRoute.queryParams.subscribe((params) => {
        if (params.page ) {
           this.dataService.annouceRoute('/secure/students');
        }
      });
    }
    this.router.navigate([path]);
  }


  ngOnInit(): void {
    this.changeStorySubscription = this.dataService.changeStoryInstance.subscribe(data => {
      if (data.storyId) {
        if (data && this.stories) {
          const selectedStory = this.stories.filter(x => parseInt(x.id) === parseInt(data.storyId))[0];
          this.setLogos(selectedStory);
        }
        // let selectedOption = this.searchOptions.filter(x => x.id === data)[0];
      }
    });
    if (this.stories) {
      this.setLogos(this.stories[0]);
    }
    // this.header = {
    //   brandLogo: 'top-logo-abcbs.svg',
    //   universityLogo: 'https://www.uccs.edu/themes/custom/uccsbase_k18/logo-reverse.svg',
    //   universityLabel: 'Colorado'
    // };
  }

  private setLogos(selectedStory: any) {
    this.header = {
      brandLogo: selectedStory.brandLogo,
      universityLogo: selectedStory.logoUrl,
      universityLabel: selectedStory.logoLabel
    };
  }

 getLogoPath(brand: string): string {
    let logoPath: string;
    switch (true) {
      case (brand === 'Anthem Blue Cross'):
        logoPath = 'top-logo-abc.svg';
        break;
      case (brand === 'Anthem Blue Cross Blue Shield'):
        logoPath = 'top-logo-abcbs.svg';
        break;
      case (brand === 'Empire Blue Cross'):
        logoPath = 'top-logo-ebc.svg';
        break;
      case (brand === 'Empire Blue Cross Blue Shield'):
        logoPath = 'top-logo-ebcbs.svg';
        break;
    }
    return logoPath;
  }

  ngOnDestroy(): void {
    if (this.ds) {
      this.ds.unsubscribe();
    }
    if (this.changeStorySubscription) {
      this.changeStorySubscription.unsubscribe();
    }
    if (this.logoutObs) {
      this.logoutObs.unsubscribe();
    }
  }
  openModalSlider(): void {
    const fwcModalSlide = new FwcModalSlide();
    fwcModalSlide.build();
    this.modal = this.sliderParent.nativeElement;
    if (this.modal.hasChildNodes()) {
      this.modal.removeChild(this.modal.firstChild);
    }
    const modalContent = this.sliderChild.nativeElement;
    if (this.modal && modalContent) {
      this.modal.appendChild(modalContent);
    }
    this.modal.setAttribute('open', '');
  }
  closeModalSlider(): void {
    const holder = this.sliderChild.nativeElement;
    const modalContent = this.sliderContent.nativeElement;
    this.modal.removeAttribute('open');
    holder.appendChild(modalContent);
  }
  logout(): void {
    this.token = null;
    this.displaySpinner = true;
    this.logoutObs = this.logoutService.logout().subscribe(data => {
      this.userCacheService.eraseAllUserData();
      localStorage.clear();
      this.dataService.userLoggedIn(false);
      this.dataService.allAccountdropdownChangeAnnouncment({ storyId: '', searchKeyword: '', route: '', storyValue: '' });
      // this.dataService.stopGlobalDrodownStream();
      this.displaySpinner = false;
      // this.router.navigate(['/login']);
      this.dataService.changeStory('','','');
       window.location.href = '/logout';
     
    }, err => {
      this.displaySpinner = false;
      this.userCacheService.eraseAllUserData();
      localStorage.clear();
      this.dataService.userLoggedIn(false);
     // this.router.navigate(['/login']);
     window.location.href = '/logout';
    
    });
  }
  toggleHeader(menu): void {
    const allDropdowns = document.getElementsByClassName('dropdown-menu');
    const allCarets = document.getElementsByClassName('nav-icon-caret');
    const allPointers = document.getElementsByClassName('horiz-nav-label');
    const dropdown = document.getElementById(menu);
    const pointer = document.getElementById(menu + '_pointer');
    const caret = document.getElementById(menu + '_caret');
    if (dropdown != null) {
      if (dropdown.classList.contains('active')) {
        dropdown.classList.remove('active');
        pointer.classList.remove('active');
        caret.classList.remove('descending');
        this.showNavBackground = false;
      } else {
        dropdown.classList.add('active');
        pointer.classList.add('active');
        caret.classList.add('descending');
        this.showNavBackground = true;
      }
    } else {
      // background.classList.remove('active');
      this.showNavBackground = false;
    }

    for (let i = 0; i < allDropdowns.length; i++) {
      if (allDropdowns[i].id !== menu) {
        const elem = document.getElementById(allDropdowns[i].id);
        if (elem.classList.contains('active')) {
          elem.classList.remove('active');
        } else {}
      }
    }
    for (let i = 0; i < allCarets.length; i++) {
      if (allCarets[i].id !== (menu + '_caret')) {
        const elem = document.getElementById(allCarets[i].id);
        if (elem.classList.contains('descending')) {
          elem.classList.remove('descending');
        } else {}
      }
    }
    for (let i = 0; i < allPointers.length; i++) {
      if (allPointers[i].id !== (menu + '_pointer')) {
        const elem = document.getElementById(allPointers[i].id);
        if (elem.classList.contains('active')) {
          elem.classList.remove('active');
        } else {}
      }
    }
  }
  tabClick(tab, menu?, subsection?): void {
    if (menu !== '') {
      this.toggleHeader(menu);
      if (subsection) {
        this.dataService.setSubSection(subsection);
        this.router.navigate([tab]);
      } else {
        this.router.navigate([tab]);
      }
    } else {
      this.dataService.setSubSection(subsection);
      this.router.navigate([tab]);
    }
  }
  handleKeyPress(event: KeyboardEvent, tab, menu?, subsection?): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.tabClick(tab, menu, subsection);
    }
  }
  handleToggleKeyPress(event: KeyboardEvent, menu): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleHeader(menu);
    }
  }
}
